import { Link } from "/App.Components";
import "./CardSection.scss";
import { CardSectionProps } from "/Models/Generated/CardSectionProps";
import EmailContactRow from "/Components/Shared/EmailContactRow/EmailContactRow";

const CardSection: React.FC<CardSectionProps> = ({
  heading,
  href,
  leadText,
  contactLabel,
  email,
  emailCopiedText,
  emailCopyLabel,
}) => {
  return (
    <div className="card-section-norad">
      {heading && (
        <a className="card-section-norad__heading-link" href={href}>
          <h2 className="card-section-norad__heading">
            <span>{heading}</span>
          </h2>
        </a>
      )}
      {leadText && <p className="card-section-norad__text">{leadText}</p>}
      <div className="card-section-norad__contact-info">
        <div className="card-section-norad__contact-label-and-link">
          <span className="card-section-norad__contact-label">{contactLabel}</span>
          {email ? (
            <EmailContactRow
              email={email}
              copiedText={emailCopiedText}
              copyLabel={emailCopyLabel}
            />
          ) : (
            <Link
              text={contactLabel + " " + heading}
              href={href + "#contact-info"}
              size="x-small"
              isExternal={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardSection;
